
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function FacetDialogRT () {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title-container' }, _createElement('div', { 'className': 'dialog-title' }, 'Filters'), _createElement('div', { 'className': 'total-hits' }, this.totalHits, ' Results')), _createElement('div', { 'className': 'buttons-container' }, _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-clear button button--primary',
        'onClick': this.clear
    }, '\n          Clear\n        '), _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-done button button--primary',
        'onClick': this.close
    }, '\n          Done\n        '))), this.withColorSearch ? [_createElement('div', {
            'className': 'cm_FacetPanel cm_facet-panel__full-width dialog-body',
            'key': '6091'
        }, [[this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function scopeInchMm1_rangeChip() {
                                    var inch = [].includes(this.field) ? '"' : '';
                                    var mm = [
                                        'wheel_bore',
                                        'wheel_offset'
                                    ].includes(this.field) ? 'mm' : '';
                                    return _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? _createElement(_Fragment, { 'key': '365' }, this.selectedRange[0], inch, mm, ' to ', this.selectedRange[1], inch, mm) : null, this.toPosInf ? _createElement(_Fragment, { 'key': '491' }, this.selectedRange[0], inch, mm, ' and more') : null, this.toNegInf ? _createElement(_Fragment, { 'key': '591' }, this.selectedRange[1], inch, mm, ' and less') : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '7210'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? 'search within' : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '2570'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? scopeInchMm1_rangeChip.apply(this, []) : this.template === 'colorChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_colorChip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), '\n  ', this.value, '\n  ', _createElement('span', { 'className': 'cm_chip-color' }, this.colorTile, ' ', this.percent, '%')), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '2640'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, 'Current Filters'), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]), _createElement('div', {
                        'className': 'cm_rdrt-btn button button--primary cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, '\n        clear all\n      '))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]], [this.facets(function () {
                function repeatFacets1(facets, facetsIndex) {
                    return [facets(function () {
                            function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                return [ShowAlwaysValues(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, '\n      ', this.value.replace(/^u/, 'U'), ' \n      ', this.field === 'Color' || this.field === 'Accent Color Shades' ? _createElement('div', {
                                            'className': 'cm_color_box cm_color_box-' + this.value.replace('Shades of ', '').toLowerCase(),
                                            'key': '144'
                                        }, '\n        ', this.value === 'Multi Colored' ? '\uD83C\uDFF3️‍\uD83C\uDF08' : '', '\n      ') : null, '\n       \n      ', _createElement('span', { 'className': 'cm_hits' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues2(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, '\n      ', this.value.replace(/^u/, 'U'), ' \n      ', this.field === 'Color' || this.field === 'Accent Color Shades' ? _createElement('div', {
                                            'className': 'cm_color_box cm_color_box-' + this.value.replace('Shades of ', '').toLowerCase(),
                                            'key': '144'
                                        }, '\n        ', this.value === 'Multi Colored' ? '\uD83C\uDFF3️‍\uD83C\uDF08' : '', '\n      ') : null, '\n       \n      ', _createElement('span', { 'className': 'cm_hits' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues3(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv' + (this.isSelected ? ' selected' : '') }, !this.isCustomRange ? [
                                            '\n      ',
                                            this.value,
                                            '\n      ',
                                            _createElement('span', {
                                                'className': 'cm_hits',
                                                'key': '861'
                                            }, this.hitCount)
                                        ] : null, this.isCustomRange ? [
                                            this.finite ? [
                                                this.range[0],
                                                ' - ',
                                                this.range[1]
                                            ] : null,
                                            this.toPosInf ? [
                                                this.range[0],
                                                ' and more'
                                            ] : null,
                                            this.toNegInf ? [
                                                this.range[1],
                                                ' and less'
                                            ] : null
                                        ] : null);
                                    }, { count: undefined })];
                            }
                            return this.field !== 'room' ? _createElement('div', {
                                'className': 'facetholder' + (this.field === 'Collection' ? ' cm_field-collection' : ''),
                                'key': '3'
                            }, _createElement('div', {
                                'className': 'facettitle',
                                'data-cm-role': 'toggle-facet',
                                'tabIndex': '0'
                            }, this.name, ' \n    ', this.isCollapsed ? [_createElement('svg', {
                                    'className': 'cm_icon cm_icon-plus-minus',
                                    'height': '20px',
                                    'role': 'img',
                                    'viewBox': '0 0 448 512',
                                    'key': '2440'
                                }, _createElement('path', { 'd': 'M416,208H272V64c0-17.67-14.33-32-32-32h-32c-17.67,0-32,14.33-32,32v144H32c-17.67,0-32,14.33-32,32v32c0,17.67,14.33,32,32,32h144v144c0,17.67,14.33,32,32,32h32c17.67,0,32-14.33,32-32V304h144c17.67,0,32-14.33,32-32v-32c0-17.67-14.33-32-32-32z' }))] : null, !this.isCollapsed ? [_createElement('svg', {
                                    'className': 'cm_icon cm_icon-plus-minus',
                                    'height': '20px',
                                    'role': 'img',
                                    'viewBox': '0 0 448 512',
                                    'key': '6480'
                                }, _createElement('path', { 'd': 'M416,208H32c-17.67,0-32,14.33-32,32v32c0,17.67,14.33,32,32,32h384c17.67,0,32-14.33,32-32v-32c0-17.67-14.33-32-32-32z' }))] : null), _createElement('div', {
                                'className': 'facetbody',
                                'role': 'list'
                            }, this.template === 'simpleFacet' ? _createElement('div', {
                                'className': 'cmTemplate_simpleFacet',
                                'key': '978'
                            }, this.showFilterInput ? _createElement('div', {
                                'className': 'filter-input',
                                'key': '1064'
                            }, [this.filterInput(function () {
                                    return _createElement('div', {
                                        'className': 'input  cm_filterInput',
                                        'placeholder': 'Enter'
                                    });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], this.inputNotEmpty ? _createElement('span', {
                                'className': 'filter-input_clear-container',
                                'onClick': this.clearInput,
                                'key': '1384'
                            }, _createElement('span', { 'className': 'filter-input_clear' }, '\u2715')) : null) : null, !this.ShowAlwaysValues.length && !this.Values.length ? [_createElement('div', {
                                    'className': 'facetdiv',
                                    'key': '15531'
                                }, _createElement('span', { 'className': 'facetentrykey' }, 'No entries found'))] : null, _createElement('div', { 'className': 'facetvalues' + (this.showFilterInput && !this.moreValuesToShow ? ' overflowed' : '') }, _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_ShowAlwaysValues' },
                                _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                            ]), _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_Values' },
                                _map(this.Values, repeatValues2.bind(this))
                            ]), this.needShowMore ? _createElement('div', {
                                'className': 'facetdiv show-all',
                                'key': '3838'
                            }, _createElement('a', {
                                'className': 'cm_show-all',
                                'data-cm-role': 'toggle-show-more'
                            }, _createElement('div', { 'className': 'cm_plus-minus' }, this.moreValuesToShow ? '+' : '–'), this.moreValuesToShow ? ['Show More'] : null, !this.moreValuesToShow ? ['Show Less'] : null)) : null), this.field === 'Size' ? _createElement('div', {
                                'className': 'cm_rdrt-btn',
                                'data-cm-role': 'next-case',
                                'key': '4229'
                            }, 'Search specific sizes') : null) : null, this.template === 'priceFacet' ? _createElement('div', {
                                'className': 'cmTemplate_priceFacet',
                                'key': '4360'
                            }, _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_Values' },
                                _map(this.Values, repeatValues3.bind(this))
                            ]), [this.Inputs(function () {
                                    return _createElement('div', { 'className': 'input cm_Inputs' }, [this.inputMin(function () {
                                            return _createElement('div', {
                                                'placeholder': 'Min price',
                                                'className': 'cm_inputMin'
                                            });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })], _createElement('span', { 'className': 'separator' }, 'to'), [this.inputMax(function () {
                                            return _createElement('div', {
                                                'placeholder': 'Max price',
                                                'className': 'cm_inputMax'
                                            });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })], _createElement('div', {
                                        'className': 'cm_rdrt-btn',
                                        'onClick': this.setCustomRange
                                    }, 'Apply'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]) : null, this.template === 'thicknessFacet' ? _createElement('div', {
                                'className': 'cmTemplate_thicknessFacet',
                                'key': '6114'
                            }, !this.isNullRange ? _createElement('div', {
                                'className': 'facetsliderinfo',
                                'key': '6206'
                            }, '\n  Selected: ', this.selectedRange[0], '" to ', this.selectedRange[1], '"\n') : null, this.isNullRange ? _createElement('div', {
                                'className': 'facetsliderinfo',
                                'key': '6344'
                            }, 'Selected: ', this.selectedRange[0], '"') : null, '\n', this.slider, '\n') : null, this.template === 'sizeFacet' ? _createElement('div', {
                                'className': 'cmTemplate_sizeFacet',
                                'key': '6471'
                            }, [this.WidthFacet(function () {
                                    return _createElement('div', { 'className': 'cm_WidthFacet' }, _createElement('div', { 'className': 'subsize' }, _createElement('span', { 'className': 'subsize-title' }, this.field, ':'), !this.isNullRange ? _createElement('span', { 'key': '102' }, this.selectedRange[0], ' - ', this.selectedRange[1]) : null, this.isNullRange ? _createElement('span', { 'key': '193' }, this.selectedRange[0]) : null, '\n  ', this.slider, '\n'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], [this.LengthFacet(function () {
                                    return _createElement('div', { 'className': 'cm_LengthFacet' }, _createElement('div', { 'className': 'subsize' }, _createElement('span', { 'className': 'subsize-title' }, this.field, ':'), !this.isNullRange ? _createElement('span', { 'key': '103' }, this.selectedRange[0], ' - ', this.selectedRange[1]) : null, this.isNullRange ? _createElement('span', { 'key': '194' }, this.selectedRange[0]) : null, '\n  ', this.slider, '\n'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], _createElement('div', {
                                'className': 'cm_rdrt-btn',
                                'data-cm-role': 'next-case'
                            }, 'Search popular sizes')) : null)) : null;
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_facets' },
                    _map(this.facets, repeatFacets1.bind(this))
                ]));
            }, {
                widgetName: 'undefined',
                items: undefined
            })])] : null, !this.withColorSearch ? [_createElement('div', {
            'className': 'cm_FacetPanel cm_facet-panel__full-width dialog-body',
            'key': '169911'
        }, [[this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function repeatI1_reviewChip(i, iIndex) {
                                    return _createElement('span', {
                                        'key': `${ this.field }|${ i }`,
                                        'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                    });
                                }
                                function scopeInchMm1_rangeChip() {
                                    var inch = [].includes(this.field) ? '"' : '';
                                    var mm = [
                                        'wheel_bore',
                                        'wheel_offset'
                                    ].includes(this.field) ? 'mm' : '';
                                    return _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? _createElement(_Fragment, { 'key': '365' }, this.selectedRange[0], inch, mm, ' to ', this.selectedRange[1], inch, mm) : null, this.toPosInf ? _createElement(_Fragment, { 'key': '491' }, this.selectedRange[0], inch, mm, ' and more') : null, this.toNegInf ? _createElement(_Fragment, { 'key': '591' }, this.selectedRange[1], inch, mm, ' and less') : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '7210'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? 'search within' : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '2570'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                    'a',
                                    {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    },
                                    _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI1_reviewChip.bind(this)),
                                    this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '4900'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? scopeInchMm1_rangeChip.apply(this, []) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, 'Current Filters'), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]), _createElement('div', {
                        'className': 'cm_rdrt-btn button button--primary cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, '\n        clear all\n      '))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]], [this.facets(function () {
                function repeatFacets1(facets, facetsIndex) {
                    return [facets(function () {
                            function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                return [ShowAlwaysValues(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, '\n      ', this.value.replace(/^u/, 'U'), ' \n      ', this.field === 'Color' || this.field === 'Accent Color Shades' ? _createElement('div', {
                                            'className': 'cm_color_box cm_color_box-' + this.value.replace('Shades of ', '').toLowerCase(),
                                            'key': '144'
                                        }, '\n        ', this.value === 'Multi Colored' ? '\uD83C\uDFF3️‍\uD83C\uDF08' : '', '\n      ') : null, '\n       \n      ', _createElement('span', { 'className': 'cm_hits' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues2(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, '\n      ', this.value.replace(/^u/, 'U'), ' \n      ', this.field === 'Color' || this.field === 'Accent Color Shades' ? _createElement('div', {
                                            'className': 'cm_color_box cm_color_box-' + this.value.replace('Shades of ', '').toLowerCase(),
                                            'key': '144'
                                        }, '\n        ', this.value === 'Multi Colored' ? '\uD83C\uDFF3️‍\uD83C\uDF08' : '', '\n      ') : null, '\n       \n      ', _createElement('span', { 'className': 'cm_hits' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues3(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv' + (this.isSelected ? ' selected' : '') }, !this.isCustomRange ? [
                                            '\n      ',
                                            this.value,
                                            '\n      ',
                                            _createElement('span', {
                                                'className': 'cm_hits',
                                                'key': '861'
                                            }, this.hitCount)
                                        ] : null, this.isCustomRange ? [
                                            this.finite ? [
                                                this.range[0],
                                                ' - ',
                                                this.range[1]
                                            ] : null,
                                            this.toPosInf ? [
                                                this.range[0],
                                                ' and more'
                                            ] : null,
                                            this.toNegInf ? [
                                                this.range[1],
                                                ' and less'
                                            ] : null
                                        ] : null);
                                    }, { count: undefined })];
                            }
                            return this.field !== 'room' ? _createElement('div', {
                                'className': 'facetholder' + (this.field === 'Collection' ? ' cm_field-collection' : ''),
                                'key': '3'
                            }, _createElement('div', {
                                'className': 'facettitle',
                                'data-cm-role': 'toggle-facet',
                                'tabIndex': '0'
                            }, this.name, ' \n    ', this.isCollapsed ? [_createElement('svg', {
                                    'className': 'cm_icon cm_icon-plus-minus',
                                    'height': '20px',
                                    'role': 'img',
                                    'viewBox': '0 0 448 512',
                                    'key': '2440'
                                }, _createElement('path', { 'd': 'M416,208H272V64c0-17.67-14.33-32-32-32h-32c-17.67,0-32,14.33-32,32v144H32c-17.67,0-32,14.33-32,32v32c0,17.67,14.33,32,32,32h144v144c0,17.67,14.33,32,32,32h32c17.67,0,32-14.33,32-32V304h144c17.67,0,32-14.33,32-32v-32c0-17.67-14.33-32-32-32z' }))] : null, !this.isCollapsed ? [_createElement('svg', {
                                    'className': 'cm_icon cm_icon-plus-minus',
                                    'height': '20px',
                                    'role': 'img',
                                    'viewBox': '0 0 448 512',
                                    'key': '6480'
                                }, _createElement('path', { 'd': 'M416,208H32c-17.67,0-32,14.33-32,32v32c0,17.67,14.33,32,32,32h384c17.67,0,32-14.33,32-32v-32c0-17.67-14.33-32-32-32z' }))] : null), _createElement('div', {
                                'className': 'facetbody',
                                'role': 'list'
                            }, this.template === 'simpleFacet' ? _createElement('div', {
                                'className': 'cmTemplate_simpleFacet',
                                'key': '978'
                            }, this.showFilterInput ? _createElement('div', {
                                'className': 'filter-input',
                                'key': '1064'
                            }, [this.filterInput(function () {
                                    return _createElement('div', {
                                        'className': 'input  cm_filterInput',
                                        'placeholder': 'Enter'
                                    });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], this.inputNotEmpty ? _createElement('span', {
                                'className': 'filter-input_clear-container',
                                'onClick': this.clearInput,
                                'key': '1384'
                            }, _createElement('span', { 'className': 'filter-input_clear' }, '\u2715')) : null) : null, !this.ShowAlwaysValues.length && !this.Values.length ? [_createElement('div', {
                                    'className': 'facetdiv',
                                    'key': '15531'
                                }, _createElement('span', { 'className': 'facetentrykey' }, 'No entries found'))] : null, _createElement('div', { 'className': 'facetvalues' + (this.showFilterInput && !this.moreValuesToShow ? ' overflowed' : '') }, _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_ShowAlwaysValues' },
                                _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                            ]), _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_Values' },
                                _map(this.Values, repeatValues2.bind(this))
                            ]), this.needShowMore ? _createElement('div', {
                                'className': 'facetdiv show-all',
                                'key': '3838'
                            }, _createElement('a', {
                                'className': 'cm_show-all',
                                'data-cm-role': 'toggle-show-more'
                            }, _createElement('div', { 'className': 'cm_plus-minus' }, this.moreValuesToShow ? '+' : '–'), this.moreValuesToShow ? ['Show More'] : null, !this.moreValuesToShow ? ['Show Less'] : null)) : null), this.field === 'Size' ? _createElement('div', {
                                'className': 'cm_rdrt-btn',
                                'data-cm-role': 'next-case',
                                'key': '4229'
                            }, 'Search specific sizes') : null) : null, this.template === 'priceFacet' ? _createElement('div', {
                                'className': 'cmTemplate_priceFacet',
                                'key': '4360'
                            }, _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_Values' },
                                _map(this.Values, repeatValues3.bind(this))
                            ]), [this.Inputs(function () {
                                    return _createElement('div', { 'className': 'input cm_Inputs' }, [this.inputMin(function () {
                                            return _createElement('div', {
                                                'placeholder': 'Min price',
                                                'className': 'cm_inputMin'
                                            });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })], _createElement('span', { 'className': 'separator' }, 'to'), [this.inputMax(function () {
                                            return _createElement('div', {
                                                'placeholder': 'Max price',
                                                'className': 'cm_inputMax'
                                            });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })], _createElement('div', {
                                        'className': 'cm_rdrt-btn',
                                        'onClick': this.setCustomRange
                                    }, 'Apply'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]) : null, this.template === 'thicknessFacet' ? _createElement('div', {
                                'className': 'cmTemplate_thicknessFacet',
                                'key': '6114'
                            }, !this.isNullRange ? _createElement('div', {
                                'className': 'facetsliderinfo',
                                'key': '6206'
                            }, '\n  Selected: ', this.selectedRange[0], '" to ', this.selectedRange[1], '"\n') : null, this.isNullRange ? _createElement('div', {
                                'className': 'facetsliderinfo',
                                'key': '6344'
                            }, 'Selected: ', this.selectedRange[0], '"') : null, '\n', this.slider, '\n') : null, this.template === 'sizeFacet' ? _createElement('div', {
                                'className': 'cmTemplate_sizeFacet',
                                'key': '6471'
                            }, [this.WidthFacet(function () {
                                    return _createElement('div', { 'className': 'cm_WidthFacet' }, _createElement('div', { 'className': 'subsize' }, _createElement('span', { 'className': 'subsize-title' }, this.field, ':'), !this.isNullRange ? _createElement('span', { 'key': '102' }, this.selectedRange[0], ' - ', this.selectedRange[1]) : null, this.isNullRange ? _createElement('span', { 'key': '193' }, this.selectedRange[0]) : null, '\n  ', this.slider, '\n'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], [this.LengthFacet(function () {
                                    return _createElement('div', { 'className': 'cm_LengthFacet' }, _createElement('div', { 'className': 'subsize' }, _createElement('span', { 'className': 'subsize-title' }, this.field, ':'), !this.isNullRange ? _createElement('span', { 'key': '103' }, this.selectedRange[0], ' - ', this.selectedRange[1]) : null, this.isNullRange ? _createElement('span', { 'key': '194' }, this.selectedRange[0]) : null, '\n  ', this.slider, '\n'));
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })], _createElement('div', {
                                'className': 'cm_rdrt-btn',
                                'data-cm-role': 'next-case'
                            }, 'Search popular sizes')) : null)) : null;
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_facets' },
                    _map(this.facets, repeatFacets1.bind(this))
                ]));
            }, {
                widgetName: 'undefined',
                items: undefined
            })])] : null));
}
        export const componentNames = ["cm:filterChips","cm:filterInput","cm:inputMin","cm:inputMax","cm:Inputs","cm:WidthFacet","cm:LengthFacet","cm:facets","cm:filterChips","cm:filterInput","cm:inputMin","cm:inputMax","cm:Inputs","cm:WidthFacet","cm:LengthFacet","cm:facets"]